import { Action } from '@ngrx/store';
export const REQUEST_BULK_RESET = `[Request] Bulk reset`;
export const BulkReset: Action = {
  type: REQUEST_BULK_RESET
};
